/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * --- REWRITE (V2 - Definitive Linting Fix) ---
 * - MISSION: To update the hook to import the `LoadingContext` from its
 * new, dedicated file.
 *
 * - RESULT: This completes the refactor, ensuring all parts of the
 * loading state logic are correctly structured and lint-free.
 */
import { useContext } from 'react';
import { LoadingContext } from '@/context/loading.context.js';

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
